<template>
  <div class="swiper-container">
    <Nav @fullPageSlide="fullPageSlide" />
    <Logo />
    <FixButton />
    <!-- <AppBtn v-if="clientWidth < 900" /> -->
    <div class="swiper-wrapper">
      <div class="swiper-slide"><Home @fullPageSlide="fullPageSlide" /></div>
      <div class="swiper-slide"><Appointment @fullPageSlide="fullPageSlide" /></div>
      <div class="swiper-slide"><Award @fullPageSlide="fullPageSlide" /></div>
      <div class="swiper-slide"><MapSwiper /></div>
      <div class="swiper-slide" v-if="this.clientWidth > 768"><Footer /></div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper/swiper-bundle.min.js";
import "swiper/swiper-bundle.min.css";
import Nav from './components/Nav';
import Logo from './components/Logo';
import FixButton from './components/FixButton';
import Home from './components/Home';
import Appointment from './components/Appointment';
import Award from './components/Award';
import MapSwiper from './components/MapSwiper';
import Footer from './components/Footer';
export default {
  components: {
    Nav,
    Logo,
    FixButton,
    Home,
    Appointment,
    Award,
    MapSwiper,
    Footer,
  },
  data() {
    return {
      SwiperObj: {},
      activeIndex: 0,
      swiperIndex: 0,
      clientWidth: document.body.clientWidth,
    };
  },
  mounted() {
    this.initSwiper();
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize");
  },
  methods: {
    handleResize() {
      this.clientWidth = document.body.clientWidth;
      this.initSwiper();
      if (this.clientWidth < 900) this.SwiperObj.allowTouchMove = true;
    },
    initSwiper() {
      let that = this;
      this.SwiperObj = new Swiper(".swiper-container", {
        direction: "vertical",
        slidesPerView: 'auto',
        speed: 1000,
        autoHeight: true,
        mousewheel: true,
        loop: false,
        autoplay: false,
        allowTouchMove: false,
        on: {
          slideChange: function () {
            that.swiperIndex = this.activeIndex;
            that.$store.commit("nav/SET_INDEX", this.activeIndex);
          },
        },
      });
    },
    fullPageSlide(index) {
      this.SwiperObj.slideTo(index, 1000, false);
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-container{
  height: 100vh;
}
</style>
